import { UserRightType } from '../../../User'

export enum ApplicationState {
	ACTIVE = 'active',
	DEACTIVATED = 'deactivated',
	_ = '',
}

export interface IApplication {
	applicationId: string
	applicationName: string
	state: ApplicationState
	creationDate: string
	expirationDate: string
	rights: {
		// NOTE: importing from inside entities
		clients: UserRightType
		licenses: UserRightType
		products: UserRightType
		instances: UserRightType
		users: UserRightType.NO_PERMISSION | UserRightType.READ_ONLY
	}
}

export interface IApplicationWithUpdate extends IApplication {
	lastSecurityUpdate: string
	userId: string
}

export interface AppSchema {
	cachedApp: IApplicationWithUpdate
	appEditable: IApplicationWithUpdate
	isLoading: boolean
	error?: string
}
